"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelfranco-piandisco": {
    "burrone": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4999fc3b": [{
      "hkey": "d93a195c",
      "slug": "castelfranco-di-sopra",
      "name": "Castelfranco di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "castelfranco-di-sopra-centro": [{
      "hkey": "d93a195c",
      "slug": "castelfranco-di-sopra",
      "name": "Castelfranco di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3615bdd4": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "skipSearch": false
    }],
    "fruscola": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38b094ee": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "skipSearch": false
    }],
    "moro-bianco": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0299ac13": [{
      "hkey": "01329ffa",
      "slug": "pian-di-sco",
      "name": "Pian di Scò",
      "primary": true,
      "skipSearch": false
    }],
    "pian-di-sco-centro": [{
      "hkey": "01329ffa",
      "slug": "pian-di-sco",
      "name": "Pian di Scò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "96264947": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "skipSearch": false
    }],
    "pratomagno": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72764e5c": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "skipSearch": false
    }],
    "san-miniato": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0ea4fbe1": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "skipSearch": false
    }],
    "sette-ponti": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "110af595": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "skipSearch": false
    }],
    "stadio": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "36314f7c": [{
      "hkey": "ba2b0584",
      "slug": "castelfranco-piandisco",
      "name": "Castelfranco Piandiscò",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;